import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import scrollTo from 'commons/scrollTo';
import browserStorage from 'components/consumer/browser-storage';
import GridWithSidebar from 'components/consumer/GridWithSidebar';
import MobileOnly from 'components/consumer/MobileOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import { usePrevious } from 'react-use';
import useScreen from 'hooks/useScreen';
import CollectionsGridEmpty from './CollectionsGridEmpty';
import CollectionsGridDesktop from './CollectionsGridDesktop';
import CollectionsGridMobile from './CollectionsGridMobile';
const CollectionsGrid = t0 => {
  const $ = _c(16);
  const {
    clearFilters,
    collections,
    filters,
    loading
  } = t0;
  const prevCollections = usePrevious(collections);
  const {
    isMobile
  } = useScreen();
  let t1;
  let t2;
  if ($[0] !== collections || $[1] !== isMobile || $[2] !== prevCollections) {
    t1 = () => {
      if (prevCollections && collections && collections.length > prevCollections.length) {
        if (!isMobile) {
          const prevScrollPosition = browserStorage().getItem("scrollPosition.collections");
          if (prevScrollPosition) {
            scrollTo(0, parseInt(prevScrollPosition, 10));
            browserStorage().setItem("scrollPosition.collections", 0);
          }
        }
      }
    };
    t2 = [collections, isMobile, prevCollections];
    $[0] = collections;
    $[1] = isMobile;
    $[2] = prevCollections;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== filters || $[6] !== isMobile) {
    t3 = selectedGridItem => {
      if (!selectedGridItem) {
        return {};
      }
      return {
        selectedItemName: selectedGridItem.name,
        selectedItemMaterial: selectedGridItem.name,
        shopThisText: "Shop This Collection",
        shopThisTextLink: `${selectedGridItem.url && !selectedGridItem.url.startsWith("/") ? "/" : ""}${selectedGridItem.url}`,
        shopThisTextClick: () => {
          if (!isMobile) {
            if (selectedGridItem) {
              browserStorage().setItem("selectedCollectionItem", JSON.stringify(selectedGridItem));
              browserStorage().setItem("collections.filters", JSON.stringify(filters));
            } else {
              browserStorage().removeItem("selectedCollectionItem");
              browserStorage().removeItem("scrollPosition.collections");
              browserStorage().removeItem("collections.filters");
            }
          }
        },
        selectedItemDescription: selectedGridItem.category_description || selectedGridItem.category_meta_description
      };
    };
    $[5] = filters;
    $[6] = isMobile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getCustomProps = t3;
  let t4;
  if ($[8] !== clearFilters || $[9] !== collections || $[10] !== loading) {
    t4 = t5 => {
      const {
        selectedGridItem: selectedGridItem_0,
        updateSelectedGridItem
      } = t5;
      if (collections.length === 0 && !loading) {
        return <CollectionsGridEmpty clearFilters={clearFilters} />;
      }
      return <><MobileOnly><CollectionsGridMobile collections={collections} loading={loading} setSelectedCollection={updateSelectedGridItem} /></MobileOnly><TabletAndDesktopOnly><CollectionsGridDesktop collections={collections} loading={loading} selectedCollection={selectedGridItem_0} setSelectedCollection={updateSelectedGridItem} /></TabletAndDesktopOnly></>;
    };
    $[8] = clearFilters;
    $[9] = collections;
    $[10] = loading;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const renderGrid = t4;
  let t5;
  if ($[12] !== getCustomProps || $[13] !== loading || $[14] !== renderGrid) {
    t5 = <GridWithSidebar gridItemType="collection" loading={loading} renderGrid={renderGrid} getCustomProps={getCustomProps} />;
    $[12] = getCustomProps;
    $[13] = loading;
    $[14] = renderGrid;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
CollectionsGrid.propTypes = {
  clearFilters: PropTypes.func,
  collections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  filters: PropTypes.object,
  loading: PropTypes.bool
};
export default CollectionsGrid;